import { render, staticRenderFns } from "./gc-footer-scan-barcode.vue?vue&type=template&id=39f78652&"
import script from "./gc-footer-scan-barcode.vue?vue&type=script&lang=js&"
export * from "./gc-footer-scan-barcode.vue?vue&type=script&lang=js&"
import style0 from "./gc-footer-scan-barcode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports